module.exports = __webpack_public_path__ + "img/symbol_7.9529877e.png";